// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WqYn","top":"styles_top__3HJoZ"};